import * as React from 'react';

export const LogoIcon = () => {
    return (
        <svg
            id="Layer_1"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 32 32"
        >
            <path d="M6.37,13.26c.08,0,.12.05.12.14v5H9.08a.11.11,0,0,1,.12.12v1.09c0,.08,0,.13-.12.13h-4c-.09,0-.13-.05-.13-.14V13.4c0-.09,0-.14.13-.14Z" />
            <path d="M14.65,13.91a4.21,4.21,0,0,1,.58,2.61,3.93,3.93,0,0,1-.58,2.6,2.62,2.62,0,0,1-2.2.7,2.86,2.86,0,0,1-2.2-.69,4.29,4.29,0,0,1-.57-2.61,4,4,0,0,1,.57-2.6,2.6,2.6,0,0,1,2.2-.71A2.79,2.79,0,0,1,14.65,13.91ZM11.48,15a3.4,3.4,0,0,0-.24,1.55,3.4,3.4,0,0,0,.24,1.55,1,1,0,0,0,1,.41,1,1,0,0,0,1-.41,3.4,3.4,0,0,0,.24-1.55A3.4,3.4,0,0,0,13.42,15a1,1,0,0,0-1-.42A1,1,0,0,0,11.48,15Z" />
            <path d="M20.53,13.36c.16.05.21.1.21.26v.81a.11.11,0,0,1-.12.12h-2a1,1,0,0,0-1,.41,3.61,3.61,0,0,0-.22,1.56,3.67,3.67,0,0,0,.22,1.56,1,1,0,0,0,1,.4h.93V16.71c0-.09,0-.14.12-.14H20.9c.09,0,.13.05.13.14V19a.41.41,0,0,1-.05.23,1.3,1.3,0,0,1-.81.42,6.13,6.13,0,0,1-1.51.16,2.72,2.72,0,0,1-2.18-.69,4.28,4.28,0,0,1-.56-2.61,4,4,0,0,1,.56-2.61c.43-.53,1.08-.7,2.18-.7A8.53,8.53,0,0,1,20.53,13.36Z" />
            <path d="M26.67,13.91a4.21,4.21,0,0,1,.58,2.61,3.93,3.93,0,0,1-.58,2.6,2.61,2.61,0,0,1-2.2.7,2.82,2.82,0,0,1-2.19-.69,4.28,4.28,0,0,1-.58-2.61,4,4,0,0,1,.58-2.6,2.58,2.58,0,0,1,2.19-.71A2.78,2.78,0,0,1,26.67,13.91ZM23.5,15a3.4,3.4,0,0,0-.24,1.55,3.4,3.4,0,0,0,.24,1.55,1,1,0,0,0,1,.41,1.05,1.05,0,0,0,1-.41,3.54,3.54,0,0,0,.24-1.55A3.54,3.54,0,0,0,25.45,15a1,1,0,0,0-1-.42A1,1,0,0,0,23.5,15Z" />
        </svg>
    );
};



// WEBPACK FOOTER //
// ./src/App/shared/icons/pt-icon-logo.tsx